export function CheckboxGroup(props: { children: React.ReactNode }) {
  const { children } = props;

  return <div className="checkbox-group">{children}</div>;
}
